var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.customer},[_c('a',{attrs:{"href":_vm.data.filePath}},[_c('img',{attrs:{"src":require("../assets/file.png"),"width":"24","height":"24"}}),_vm._v("\n    "+_vm._s(_vm.data.Text)+"\n  ")]),_vm._v(" "),_c('br')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f5eb3d8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FileMessage.vue
// module id = null
// module chunks = 